
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Users, Info, AlertTriangle, Globe } from 'lucide-react';
import UsersSettings from '@/components/settings/UsersSettings';
import SystemInfo from '@/components/settings/SystemInfo';
import { BikeInconsistenciesAnalytics } from '@/components/analytics/diagnostics';
import { ProxySettings } from '@/components/settings/ProxySettings';

const SettingsPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Настройки</h1>
      </div>

      <Tabs defaultValue="users" className="space-y-4">
        <TabsList className="grid grid-cols-4">
          <TabsTrigger value="users" className="flex items-center gap-2">
            <Users className="h-4 w-4" />
            <span>Пользователи</span>
          </TabsTrigger>
          <TabsTrigger value="system" className="flex items-center gap-2">
            <Info className="h-4 w-4" />
            <span>Система</span>
          </TabsTrigger>
          <TabsTrigger value="proxy" className="flex items-center gap-2">
            <Globe className="h-4 w-4" />
            <span>Прокси</span>
          </TabsTrigger>
          <TabsTrigger value="diagnostics" className="flex items-center gap-2">
            <AlertTriangle className="h-4 w-4" />
            <span>Диагностика</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="users">
          <UsersSettings />
        </TabsContent>

        <TabsContent value="system">
          <SystemInfo />
        </TabsContent>

        <TabsContent value="proxy">
          <ProxySettings />
        </TabsContent>

        <TabsContent value="diagnostics">
          <BikeInconsistenciesAnalytics />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default SettingsPage;
